// extracted by mini-css-extract-plugin
export default {"verticalShell":"App_verticalShell__umCU2","verticalMain":"App_verticalMain__FbUVv"};